import axios from "axios";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { returnPathFromSearchParam } from "../lib/returnAfterLogin";

const Login = ({ setUser }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const returnTo = returnPathFromSearchParam(searchParams.get("next"));

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const res = await axios.post("/api/auth/login", { username, password }, { withCredentials: true });
            setUser(res.data.user);
            setSuccess("Вхід виконано успішно!");
            const dest = returnTo || "/";
            const delayMs = returnTo ? 400 : 2000;
            setTimeout(() => {
                navigate(dest, { replace: true });
            }, delayMs);
        } catch (err) {
            setError(err.response?.data?.message || "Помилка входу");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center w-100 px-3 py-5">
            <form
                autoComplete="on"
                onSubmit={handleLogin}
                className="p-4 border rounded bg-white"
                style={{ width: "100%", maxWidth: "400px" }}
            >
                <h4 className="mb-4 text-center">Вхід</h4>

                <div className="mb-3">
                    <input
                        className="form-control"
                        placeholder="Логiн"
                        name="username"
                        autoComplete="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoFocus
                    />
                </div>

                <div className="mb-3">
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Пароль"
                        name="password" // 👈 обязательно
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                {error && <p className="text-danger mb-2">{error}</p>}
                {success && <p className="text-success mb-2">{success}</p>}
                {!success && (
                <button type="submit" className="btn btn-dark w-100" disabled={loading}>
                    {loading ? "Вхід..." : "Увійти"}
                </button>)}
            </form>
        </div>
    );
};

export default Login;
